import { useEffect, useState, useRef } from 'react';
import { returnIntervalAvailable } from '../utils/functions';

export default function CheckoutButton({ gadgetApi, settings, cartAttributes, hourRef, setCartAttributes }) {
	const checkoutButton = document.querySelector('button[name="checkout"]');
	const [allRequiredFieldsFilled, setAllRequiredFieldsFilled] = useState(false);

	useEffect(() => {
		if (cartAttributes.deliveryMethod === 'digitalProductsOnly') {
			if (cartAttributes.invoiceType === 'pj' && !cartAttributes.cui) {
				//console.log('CUI is required for legal entities');
				setAllRequiredFieldsFilled(false);
				
				return;
			}
			setAllRequiredFieldsFilled(true);

			return;
		}

		setAllRequiredFieldsFilled(
			cartAttributes.deliveryMethod && cartAttributes.desiredDate && cartAttributes.desiredTime
		);

		if (cartAttributes.deliveryMethod === 'pickup' && !cartAttributes.pickupLocation) {
			//console.log('Pickup location is required');
			setAllRequiredFieldsFilled(false);
		}

		if (cartAttributes.invoiceType === 'pj' && !cartAttributes.cui) {
			//console.log('CUI is required for legal entities');
			setAllRequiredFieldsFilled(false);
		}
	}, [cartAttributes]);

	const handleCheckout = async () => {
		const timeValue = cartAttributes.desiredTime?.replaceAll(' ', '') || '';
		const dateAndHour = `${cartAttributes.desiredDate}T${timeValue}`;
		//console.log('dateAndHour', dateAndHour);

		if (cartAttributes.deliveryMethod === 'delivery') {
			const dateAndHourStillValid = await returnIntervalAvailable(
				dateAndHour,
				gadgetApi,
				settings.maxPerHour,
				cartAttributes.cartToken
			);
			//console.log('dateAndHourStillValid', dateAndHourStillValid);
			if (!dateAndHourStillValid) {
				if (hourRef?.current) {
					console.log('hourRef found, scrolling...');
					hourRef.current.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
				} else {
					// console.log('hourRef not found');
				}

				setCartAttributes((prev) => ({
					...prev,
					intervalUnavailable: true,
				}));

				return;
			}
		}

		checkoutButton?.click();
	};

	return (
		<>
			<div className="checkout-button">
				{/* {!allRequiredFieldsFilled && <p className="text-error">Va rugam sa completati toate campurile obligatorii.</p>} */}
				<button
					className="button button--lg button--primary"
					disabled={!allRequiredFieldsFilled}
					onClick={() => handleCheckout()}
				>
					{settings.buttonCheckoutLabel}
				</button>
			</div>
		</>
	);
}
